module.exports = new __parcel__URL__("94849_h.c791420a.jpg").toString();